export enum ICON_TYPE {OZ_ACCOUNT,
    OZ_ARROW_DOWN,
    OZ_ARROW_LEFT,
    OZ_ARROW_RIGHT,
    OZ_ARROW_UP,
    OZ_CHECK_MARK,
    OZ_CLOCK,
    OZ_CLOSE,
    OZ_ENVELOPE_IN_MOTION,
    OZ_ENVELOPE_STATIC,
    OZ_FACEBOOK,
    OZ_HAMBURGER,
    OZ_INSTAGRAM,
    OZ_LOCK,
    OZ_MAGNIFYING_GLASS,
    OZ_PINTEREST,
    OZ_PLUS,
    OZ_SNAPCHAT,
    OZ_STAR,
    OZ_TICKETS,
    OZ_TIKTOK,
    OZ_TOOLTIP,
    OZ_TWITTER,
    OZ_YOUTUBE,
}
